import styled from "@emotion/styled";
import { Badge, Box, Typography } from "@mui/material";
import { HHNTheme } from "hhn-commons";
import Icon from "../../common/Icon/Icon";

export const StatusImgOutline = styled(Box)`
  height: 60px;
  width: 60px;
  background-color: ${HHNTheme.surfaceVariant};
  border-radius: 50%;
`;

export const PatientsCountBadge = styled(Badge)`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: -2px 5px 20px rgba(0, 0, 0, 0.46);
`;

export const AssignedPatientWrapper = styled(Box)`
  position: relative;
  margin-top: 8px;
  cursor: pointer;
`;

export const PatientsCount = styled(Typography)`
  font-size: 14px;
`;

export const AssignedPatientsContainer = styled(Box)`
  padding: 20px;
`;

export const AssignedPatientsTitle = styled(Typography)`
  margin-bottom: 5px;
`;

export const AssignedPatientsList = styled(Box)`
  display: flex;
  gap: 16px;
`;

export const ArrowDown = styled(Icon)`
  width: 60px;
  height: 60px;
  margin-top: -16px;
  margin-bottom: -16px;
  margin-left: 72px;
`;

export const ProgressBarContainer = styled(Box)`
  margin-bottom: 10px;
`;

export const ProgressBar = styled(Box)`
  height: 6px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  background-color: ${HHNTheme.surfaceVariant};
`;

export const Segment = styled(Box)<{ width: number; color: string }>`
  height: 100%;
  width: ${({ width }) => width}%;
  background-color: ${({ color }) => color};
`;

export const ProgressBreakdownContainer = styled(Box)`
  display: flex;
  gap: 16px;
`;

export const ProgressBreakdownItemContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StatusIndicator = styled(Box)<{ color: string }>`
  width: 12px;
  height: 12px;
  background-color: ${({ color }) => color};
`;

export const AssignedPatientsByStatusContainer = styled(Box)`
  padding: 16px 0;
`;

export const FilteredPatientsListWrapper = styled(Box)`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 500px;
`;

export const AssignedPatientsLoader = styled(Box)`
  height: 212px;
`;
